export const CREATE_FULFILLMENT_SUCCESS = "CREATE_FULFILLMENT_SUCCESS";
export const CREATE_FULFILLMENT_FAILED = "CREATE_FULFILLMENT_FAILED";
export const CREATE_FULFILLMENT_PENDING = "CREATE_FULFILLMENT_PENDING";
